import { render, staticRenderFns } from "./VehiculosGridSugal.vue?vue&type=template&id=769a61c5&"
import script from "./VehiculosGridSugal.vue?vue&type=script&lang=ts&"
export * from "./VehiculosGridSugal.vue?vue&type=script&lang=ts&"
import style0 from "./VehiculosGridSugal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('769a61c5', component.options)
    } else {
      api.reload('769a61c5', component.options)
    }
    module.hot.accept("./VehiculosGridSugal.vue?vue&type=template&id=769a61c5&", function () {
      api.rerender('769a61c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Inicio/VehiculosGrid/VehiculosGridSugal.vue"
export default component.exports